
import { useState } from 'react';

export default function CaseStudies() {
  const [showInquiryForm, setShowInquiryForm] = useState(false);
  const [selectedCase, setSelectedCase] = useState<string | null>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const caseStudies = [
    {
      id: 'beverage',
      industry: '飲料業界',
      type: '機械式パレタイザー',
      company: 'A飲料株式会社',
      challenge: '2ライン同時稼働で人員不足が深刻化。夜勤作業者の確保が困難な状況でした。',
      image: 'https://readdy.ai/api/search-image?query=Industrial%20beverage%20factory%20with%20automated%20palletizer%20robot%20stacking%20beverage%20cases%20on%20pallets%2C%20modern%20production%20line%2C%20clean%20facility%20with%20stainless%20steel%20equipment%2C%20professional%20industrial%20photography%2C%20blue%20lighting&width=600&height=400&seq=case-study-beverage&orientation=landscape',
      results: {
        '処理能力': '90秒/1ケースの高速処理',
        '稼働時間': '2時間無人稼働を実現',
        '人員削減': '作業員3名から1名に削減',
        'コスト削減': '年間420万円の人件費削減'
      },
      details: {
        beforeSituation: '2ライン同時稼働により、パレット積み付け作業に6名の作業者が必要でした。夜勤シフトの人員確保が困難で、残業代も膨らんでいました。また、重量物の取り扱いによる腰痛などの労災リスクも課題となっていました。',
        afterSituation: '機械式パレタイザー導入により、2ライン合計で2名の監視者のみで稼働可能となりました。夜勤時間帯は完全無人稼働を実現し、労災リスクも大幅に軽減されました。品質の安定化により顧客満足度も向上しています。',
        timeline: '6ヶ月（設計3ヶ月、設置3ヶ月）',
        investment: '2,800万円',
        roi: '3.2年で投資回収'
      },
      testimonial: {
        person: '製造部長 田中様',
        comment: '導入前は人員確保に苦労していましたが、今では安定した生産体制を構築できています。作業者の負担も大幅に軽減され、職場環境が改善されました。'
      }
    },
    {
      id: 'food',
      industry: '食品製造業',
      type: '多関節ロボット',
      company: 'B食品工業株式会社',
      challenge: '6種類の製品を扱う多品種生産で、品種切り替えに時間がかかっていました。',
      image: 'https://readdy.ai/api/search-image?query=Multi-axis%20articulated%20robot%20in%20food%20manufacturing%20facility%20handling%20various%20packaged%20products%2C%20flexible%20automation%20system%2C%20clean%20food%20processing%20environment%2C%20multiple%20product%20types&width=600&height=400&seq=case-food&orientation=landscape',
      results: {
        '処理能力': '500ケース/時の安定処理',
        '品種対応': '6種類の製品を同時積み付け',
        '切り替え時間': '品種切り替え時間90%短縮',
        '品質向上': '積み付けミス99%削減'
      },
      details: {
        beforeSituation: '多品種の食品を扱うため、製品ごとに積み付けパターンを変更する必要がありました。手作業では品種切り替えに30分程度かかり、積み付けミスによる荷崩れも頻発していました。',
        afterSituation: '多関節ロボットの柔軟性により、プログラム切り替えだけで異なる製品に対応可能となりました。積み付け精度が向上し、荷崩れによるクレームもほぼゼロになりました。',
        timeline: '4ヶ月（設計2ヶ月、設置2ヶ月）',
        investment: '2,200万円',
        roi: '2.8年で投資回収'
      },
      testimonial: {
        person: '生産管理課長 佐藤様',
        comment: '多品種対応が必要な当社にとって、プログラム変更だけで対応できる柔軟性は非常に助かっています。品質も安定し、お客様からの評価も上がりました。'
      }
    },
    {
      id: 'logistics',
      industry: '物流業界',
      type: '直交ロボット',
      company: 'C物流センター',
      challenge: '限られたスペースで効率化を図る必要があり、初期投資も抑えたい状況でした。',
      image: 'https://readdy.ai/api/search-image?query=Compact%20cartesian%20robot%20palletizer%20in%20logistics%20warehouse%2C%20space-saving%20automation%20solution%2C%20organized%20storage%20facility%20with%20efficient%20layout%2C%20modern%20logistics%20center&width=600&height=400&seq=case-logistics&orientation=landscape',
      results: {
        '処理能力': '300ケース/時の効率処理',
        '稼働時間': '24時間無人稼働',
        '設置面積': '40㎡の省スペース設置',
        '投資効果': '初期投資30%削減'
      },
      details: {
        beforeSituation: '物流センターの拡張が困難な中、処理能力向上が求められていました。限られた予算と設置スペースの制約があり、効率的なソリューションが必要でした。',
        afterSituation: '直交ロボットの省スペース設計により、既存レイアウトを大きく変更することなく導入できました。24時間稼働により処理能力が大幅に向上し、人件費も削減されました。',
        timeline: '3ヶ月（設計1ヶ月、設置2ヶ月）',
        investment: '1,800万円',
        roi: '2.5年で投資回収'
      },
      testimonial: {
        person: 'センター長 鈴木様',
        comment: '限られたスペースと予算の中で最大の効果を得ることができました。24時間稼働により、お客様への対応力も大幅に向上しています。'
      }
    },
    {
      id: 'chemical',
      industry: '化学工業',
      type: '大型機械式',
      company: 'D化学工業株式会社',
      challenge: '50kg重量物の取り扱いで労災リスクが高く、安全性向上が急務でした。',
      image: 'https://readdy.ai/api/search-image?query=Heavy-duty%20mechanical%20palletizer%20in%20chemical%20plant%2C%20robust%20industrial%20equipment%20handling%20heavy%20packages%2C%20safety-focused%20industrial%20environment%2C%20large-scale%20manufacturing%20facility&width=600&height=400&seq=case-chemical&orientation=landscape',
      results: {
        '処理能力': '800ケース/時の大容量処理',
        '重量対応': '50kg重量物の安全な積み付け',
        '安全性': '労災事故ゼロを継続中',
        '耐久性': '連続稼働10年保証'
      },
      details: {
        beforeSituation: '化学製品の重量物取り扱いにより、作業者の腰痛や怪我が頻発していました。安全対策のコストも増加し、生産性向上との両立が課題となっていました。',
        afterSituation: '大型機械式パレタイザーにより、重量物の完全自動化を実現しました。作業者は安全な場所から監視するだけとなり、労災リスクが大幅に軽減されました。',
        timeline: '8ヶ月（設計4ヶ月、設置4ヶ月）',
        investment: '3,500万円',
        roi: '4.2年で投資回収'
      },
      testimonial: {
        person: '安全管理責任者 山田様',
        comment: '重量物による労災リスクが完全に解消され、作業者も安心して働けるようになりました。安全性と生産性の両立を実現できています。'
      }
    }
  ];

  const handleInquirySubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d3c8ocsef3sotc9j5t8g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        alert('お問い合わせありがとうございます。担当者より3営業日以内にご連絡いたします。');
        form.reset();
        setShowInquiryForm(false);
      }
    } catch (error) {
      alert('送信に失敗しました。お電話でのお問い合わせもお受けしております。');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-slate-800 text-white py-4 px-6">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <a href="/" className="text-2xl font-bold hover:text-orange-400 cursor-pointer" style={{ fontFamily: '"Arial", "Helvetica", sans-serif' }}>パレタイザーナビ</a>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <a href="/palletizer-basics" className="hover:text-orange-400 transition-colors cursor-pointer">パレタイザーとは</a>
            <a href="/selection-guide" className="hover:text-orange-400 transition-colors cursor-pointer">機種選定ガイド</a>
            <a href="/decision-criteria" className="hover:text-orange-400 transition-colors cursor-pointer">導入判断基準</a>
            <a href="/case-studies" className="hover:text-orange-400 transition-colors cursor-pointer">導入事例</a>
            <a href="/manufacturers-products" className="hover:text-orange-400 transition-colors cursor-pointer">メーカー・製品</a>
            <a href="/peripheral-systems" className="hover:text-orange-400 transition-colors cursor-pointer">周辺機器</a>
            <a href="/alternatives-comparison" className="hover:text-orange-400 transition-colors cursor-pointer">代替案・比較</a>
          </nav>

          <div className="flex items-center space-x-6">
            <button 
              onClick={() => setShowInquiryForm(true)}
              className="bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              見積依頼・お問い合わせ
            </button>
            
            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-white cursor-pointer"
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-slate-700">
            <nav className="flex flex-col space-y-4 mt-4">
              <a href="/palletizer-basics" className="hover:text-orange-400 transition-colors cursor-pointer">パレタイザーとは</a>
              <a href="/selection-guide" className="hover:text-orange-400 transition-colors cursor-pointer">機種選定ガイド</a>
              <a href="/decision-criteria" className="hover:text-orange-400 transition-colors cursor-pointer">導入判断基準</a>
              <a href="/case-studies" className="hover:text-orange-400 transition-colors cursor-pointer">導入事例</a>
              <a href="/manufacturers-products" className="hover:text-orange-400 transition-colors cursor-pointer">メーカー・製品</a>
              <a href="/peripheral-systems" className="hover:text-orange-400 transition-colors cursor-pointer">周辺機器</a>
              <a href="/alternatives-comparison" className="hover:text-orange-400 transition-colors cursor-pointer">代替案・比較</a>
              <button 
                onClick={() => {
                  setShowInquiryForm(true);
                  setMobileMenuOpen(false);
                }}
                className="bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors text-left"
              >
                見積依頼・お問い合わせ
              </button>
            </nav>
          </div>
        )}
      </header>

      {/* Breadcrumb */}
      <div className="bg-slate-50 py-4 px-6">
        <div className="max-w-7xl mx-auto">
          <nav className="flex items-center space-x-2 text-sm text-slate-600">
            <a href="/" className="hover:text-blue-600 cursor-pointer">ホーム</a>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-slate-800 font-semibold">導入事例</span>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-orange-600 to-orange-800 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold mb-6">導入事例集</h1>
          <p className="text-xl text-orange-100 mb-8">業界別の成功事例で効果を実感</p>
        </div>
      </section>

      {/* Case Studies Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">業界別導入実績</h2>
          <div className="grid lg:grid-cols-2 gap-8">
            {caseStudies.map((caseStudy, index) => (
              <div key={index} className="bg-slate-50 rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <img 
                  src={caseStudy.image}
                  alt={`${caseStudy.industry}導入事例`}
                  className="w-full h-64 object-cover"
                />
                <div className="p-8">
                  <div className="flex items-center mb-4">
                    <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm font-semibold mr-3">
                      {caseStudy.industry}
                    </span>
                    <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                      {caseStudy.type}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-800 mb-3">{caseStudy.company}</h3>
                  <p className="text-slate-600 mb-4">{caseStudy.challenge}</p>
                  
                  <div className="grid md:grid-cols-2 gap-4 mb-6">
                    {Object.entries(caseStudy.results).map(([key, value], resultIndex) => (
                      <div key={resultIndex} className="flex items-start">
                        <i className="ri-check-line text-green-600 mr-2 mt-1"></i>
                        <span className="text-sm text-slate-600">{value}</span>
                      </div>
                    ))}
                  </div>

                  <button 
                    onClick={() => setSelectedCase(selectedCase === caseStudy.id ? null : caseStudy.id)}
                    className="bg-orange-500 hover:bg-orange-600 px-6 py-2 rounded-lg text-white font-bold whitespace-nowrap cursor-pointer transition-colors"
                  >
                    {selectedCase === caseStudy.id ? '詳細を閉じる' : '詳細を見る'}
                  </button>
                </div>

                {/* Detailed Information */}
                {selectedCase === caseStudy.id && (
                  <div className="bg-white p-8 border-t border-slate-200">
                    <div className="grid lg:grid-cols-2 gap-8">
                      <div>
                        <h4 className="text-xl font-bold text-slate-800 mb-4">導入前の状況</h4>
                        <p className="text-slate-600 mb-6">{caseStudy.details.beforeSituation}</p>
                        
                        <h4 className="text-xl font-bold text-slate-800 mb-4">導入後の効果</h4>
                        <p className="text-slate-600 mb-6">{caseStudy.details.afterSituation}</p>
                      </div>
                      
                      <div>
                        <h4 className="text-xl font-bold text-slate-800 mb-4">導入詳細</h4>
                        <div className="space-y-3 mb-6">
                          <div className="flex justify-between">
                            <span className="font-semibold text-slate-700">導入期間:</span>
                            <span className="text-slate-600">{caseStudy.details.timeline}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="font-semibold text-slate-700">投資額:</span>
                            <span className="text-slate-600">{caseStudy.details.investment}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="font-semibold text-slate-700">投資回収:</span>
                            <span className="text-slate-600">{caseStudy.details.roi}</span>
                          </div>
                        </div>

                        <div className="bg-blue-50 p-4 rounded-lg">
                          <h5 className="font-bold text-blue-800 mb-2">{caseStudy.testimonial.person}</h5>
                          <p className="text-blue-700 text-sm italic">"{caseStudy.testimonial.comment}"</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Success Metrics */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">導入効果サマリー</h2>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { metric: '平均コスト削減', value: '420万円/年', icon: 'ri-money-dollar-circle-line', color: 'green' },
              { metric: '平均投資回収期間', value: '3.0年', icon: 'ri-time-line', color: 'blue' },
              { metric: '人員削減効果', value: '65%', icon: 'ri-team-line', color: 'purple' },
              { metric: '労災事故削減', value: '95%', icon: 'ri-shield-check-line', color: 'red' }
            ].map((stat, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-lg text-center">
                <div className={`w-16 h-16 bg-${stat.color}-100 rounded-full flex items-center justify-center mx-auto mb-4`}>
                  <i className={`${stat.icon} text-3xl text-${stat.color}-600`}></i>
                </div>
                <div className="text-3xl font-bold text-slate-800 mb-2">{stat.value}</div>
                <div className="text-slate-600">{stat.metric}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industry Success Stories */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">業界別成功のポイント</h2>
          <div className="grid lg:grid-cols-2 gap-12">
            {[
              {
                industry: '飲料業界',
                points: [
                  '高処理能力による大量生産対応',
                  '連続稼働による生産性向上',
                  '品質安定化による顧客満足度向上'
                ],
                recommendation: '機械式パレタイザー',
                color: 'blue'
              },
              {
                industry: '食品製造業',
                points: [
                  '多品種対応による生産柔軟性',
                  '衛生管理レベルの向上',
                  '品種切り替え時間の大幅短縮'
                ],
                recommendation: '多関節ロボット',
                color: 'green'
              },
              {
                industry: '物流業界',
                points: [
                  '省スペース設置による効率化',
                  '24時間稼働による処理能力向上',
                  '初期投資抑制による早期導入'
                ],
                recommendation: '直交ロボット',
                color: 'purple'
              },
              {
                industry: '化学工業',
                points: [
                  '重量物対応による安全性向上',
                  '労災リスク排除による職場環境改善',
                  '高耐久性による長期運用'
                ],
                recommendation: '大型機械式',
                color: 'red'
              }
            ].map((industry, index) => (
              <div key={index} className="bg-slate-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-slate-800 mb-4">{industry.industry}</h3>
                <div className={`bg-${industry.color}-100 p-3 rounded-lg mb-4`}>
                  <span className="font-semibold text-slate-700">推奨機種: </span>
                  <span className={`text-${industry.color}-700 font-bold`}>{industry.recommendation}</span>
                </div>
                <ul className="space-y-3">
                  {industry.points.map((point, pointIndex) => (
                    <li key={pointIndex} className="flex items-start">
                      <i className={`ri-star-line text-${industry.color}-600 mr-3 mt-1`}></i>
                      <span className="text-slate-600">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-orange-600 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-8">同じような課題をお持ちの方はこちら</h2>
          <p className="text-xl mb-8">業界実績を踏まえた最適なソリューションをご提案いたします</p>
          <div className="flex justify-center space-x-6">
            <a 
              href="/decision-criteria"
              className="bg-white text-orange-600 hover:bg-slate-100 px-10 py-4 rounded-lg text-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              導入判断基準を確認
            </a>
            <button 
              onClick={() => setShowInquiryForm(true)}
              className="bg-slate-800 hover:bg-slate-700 px-10 py-4 rounded-lg text-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              類似事例の相談をする
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Arial", "Helvetica", sans-serif' }}>パレタイザーナビ</h3>
              <p className="text-slate-300 mb-4">パレタイザー専門企業として、製造業・物流業の自動化をサポートします。</p>
              <div className="flex space-x-4">
                <i className="ri-phone-line text-orange-400"></i>
                <span>03-1234-5678</span>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">サービス</h4>
              <ul className="space-y-2 text-slate-300">
                <li><a href="/selection-guide" className="hover:text-orange-400 cursor-pointer">機械式パレタイザー</a></li>
                <li><a href="/selection-guide" className="hover:text-orange-400 cursor-pointer">多関節ロボット</a></li>
                <li><a href="/selection-guide" className="hover:textorange-400 cursor-pointer">直交ロボット</a></li>
                <li><a href="/peripheral-systems" className="hover:text-orange-400 cursor-pointer">保守・メンテナンス</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">詳細情報</h4>
              <ul className="space-y-2 text-slate-300">
                <li><a href="/palletizer-basics" className="hover:text-orange-400 cursor-pointer">パレタイザーとは</a></li>
                <li><a href="/decision-criteria" className="hover:text-orange-400 cursor-pointer">導入判断基準</a></li>
                <li><a href="/case-studies" className="hover:text-orange-400 cursor-pointer">導入事例</a></li>
                <li><a href="/manufacturers-products" className="hover:text-orange-400 cursor-pointer">メーカー・製品</a></li>
                <li><a href="/peripheral-systems" className="hover:text-orange-400 cursor-pointer">周辺機器・システム</a></li>
                <li><a href="/alternatives-comparison" className="hover:text-orange-400 cursor-pointer">代替案・比較</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">会社情報</h4>
              <ul className="space-y-2 text-slate-300">
                <li>〒174-0000 東京都板橋区</li>
                <li>設立：1985年</li>
                <li>従業員数：120名</li>
                <li>ISO9001認証取得</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-700 mt-8 pt-8 text-center text-slate-400">
            <p>&copy; 2024 パレタイザーナビ. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="text-orange-400 hover:text-orange-300 ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>

      {/* Inquiry Form Modal */}
      {showInquiryForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-slate-800">お問い合わせ・見積もり</h3>
                <button 
                  onClick={() => setShowInquiryForm(false)}
                  className="text-slate-500 hover:text-slate-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <form id="case-studies-form" data-readdy-form onSubmit={handleInquirySubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">会社名 *</label>
                    <input 
                      type="text" 
                      name="company" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">お名前 *</label>
                    <input 
                      type="text" 
                      name="name" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">電話番号 *</label>
                    <input 
                      type="tel" 
                      name="phone" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">メールアドレス *</label>
                    <input 
                      type="email" 
                      name="email" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">業種</label>
                  <select name="industry" className="w-full p-3 pr-8 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500">
                    <option value="">選択してください</option>
                    <option value="飲料業界">飲料業界</option>
                    <option value="食品製造業">食品製造業</option>
                    <option value="物流業界">物流業界</option>
                    <option value="化学工業">化学工業</option>
                    <option value="その他">その他</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">興味のある事例</label>
                  <div className="space-y-2">
                    {caseStudies.map((caseStudy, index) => (
                      <label key={index} className="flex items-center">
                        <input type="checkbox" name="interested_cases" value={caseStudy.company} className="mr-2" />
                        {caseStudy.company}（{caseStudy.industry}）
                      </label>
                    ))}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">現在の課題・知りたい内容</label>
                  <textarea 
                    name="inquiry_details" 
                    rows={4} 
                    maxLength={500}
                    className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="類似する課題や詳しく知りたい点をお聞かせください（500文字以内）"
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">希望連絡方法</label>
                  <div className="flex space-x-4">
                    <label className="flex items-center">
                      <input type="radio" name="contact_method" value="電話" className="mr-2" />
                      電話
                    </label>
                    <label className="flex items-center">
                      <input type="radio" name="contact_method" value="メール" className="mr-2" />
                      メール
                    </label>
                    <label className="flex items-center">
                      <input type="radio" name="contact_method" value="どちらでも" className="mr-2" defaultChecked />
                      どちらでも
                    </label>
                  </div>
                </div>
                <button 
                  type="submit" 
                  className="w-full bg-orange-500 hover:bg-orange-6
0 text-white py-3 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
                >
                  送信する
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
